import { Component } from "react";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) { console.error("[MIO] Erro de interface:", error, info?.componentStack); }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="error-boundary-screen">
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8 max-w-md w-full text-center">
          <AlertTriangle className="w-10 h-10 mx-auto text-amber-400" strokeWidth={1.5} />
          <div className="font-display text-xl text-slate-50 mt-4">Esta página encontrou um problema</div>
          <p className="text-slate-400 text-sm mt-2">
            Os dados já guardados estão seguros. Pode tentar novamente ou voltar ao painel.
          </p>
          <div className="flex flex-wrap gap-2 justify-center mt-6">
            <button
              data-testid="error-boundary-retry"
              onClick={() => this.setState({ error: null })}
              className="inline-flex items-center gap-2 rounded-full bg-sky-500 hover:bg-sky-400 text-slate-950 px-4 py-2 text-sm font-medium transition-colors"
            >
              <RotateCcw className="w-4 h-4" /> Tentar novamente
            </button>
            <a
              data-testid="error-boundary-home"
              href={this.props.homeHref || "/"}
              className="inline-flex items-center gap-2 rounded-full border border-slate-700 hover:border-slate-500 text-slate-200 px-4 py-2 text-sm transition-colors"
            >
              <Home className="w-4 h-4" /> {this.props.homeLabel || "Voltar ao painel"}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
